/** Max characters sent in one TTS request (backend should accept at least this much). */
export const MAX_TTS_TEXT_LENGTH = 10_000;
